<template>
  <div class="item name">
    <div>
      <img
        v-if="member.avatar && !hideAvatar"
        :class="{ inactive: !member.active }"
        class="avatar"
        :style="{
          background: 'unset',
        }"
        :src="member.avatar.url"
      />
      <img
        v-else-if="!hideAvatar"
        :src="getAvatar()"
        :class="{ inactive: !member.active }"
        class="avatar"
        :style="{
          background: member.color ? (member.color && member.status !== 'invited' ? member.color : '#D1D4F0') : '#D1D4F0',
        }"
      />
      <field class="name-field" :class="{ inactive: !member.active }" :title="member.fullName || member.name" :description="member.email" />
    </div>
  </div>
</template>

<script>
import Field from '@/components/UI/Field'
import Constants from '@/components/Constants'
export default {
  components: {
    Field,
  },
  mixins: [Constants],
  props: {
    member: Object,
    hideAvatar: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    getAvatar() {
      let member = this.member
      if (this.member.userId && member.avatarIndex === undefined) {
        member.avatarIndex = Math.floor(Math.random() * this.avatars().length)
      } else if (!member.userId) {
        member.userId = {}
        member.avatarIndex = Math.floor(Math.random() * this.avatars().length)
      }
      return require('@/assets/avatars/' + this.avatars()[member.avatarIndex])
    },
  },
}
</script>
<style lang="scss">
.item {
  &.name {
    > div {
      p.field-title {
        text-transform: none;
        font-size: 15px;
        font-family: $semibold;
        line-height: 21px;
        margin: 0px;
      }
      p.field-description {
        font-family: $regular;
        font-size: 14px;
        line-height: 21px;
        margin: 0px;
        word-break: break-all;
      }
    }
    .inactive {
      p {
        color: $bluebell;
      }
    }
  }
}
</style>
<style lang="scss" scoped>
.item {
  &.name {
    > div {
      display: flex;
      flex-direction: row;
      align-items: center;
      img {
        width: 26px;
        height: 26px;
        border-radius: 50px;
        margin-right: 16px;
      }
    }
    .name-field {
      word-break: break-word;
    }
    .avatar.inactive {
      opacity: 0.5;
    }
  }
}
</style>
